import styled, { css } from "styled-components";
import { PropsWithChildren } from "react";

export function TableContainer({
  children,
  ...props
}: PropsWithChildren<{ className?: string; [key: string]: any }>) {
  return <Wrapper {...props}>{children}</Wrapper>;
}

const Wrapper = styled.div<{ [key: string]: any }>`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${(p) =>
    p.noGap &&
    css`
      padding: 0;
    `}
`;
